import type OlMap from "ol/Map";
import type Draw from "ol/interaction/Draw";
import { DRAW_TOOL_EXIT_CURSOR } from "src/domains/shared/constants/mapToolButton";

/**
 * 그리기 도구의 UI 만 해제한다 — 버튼 선택 해제·커서 복원·Draw 인터랙션 제거.
 * 지도 전역 `isDrawing` 플래그는 해제 시점이 경로마다 달라 호출자가 따로 내린다.
 *
 * 한 번에 끝나는 도구(`PointDrawButton`·`TextDrawButton`·`RectangleDrawButton`)가 읽는다.
 * 선·면(`PolylineDrawButton`·`PolygonDrawButton`)은 스케치 레이어·소스 정리와 DoubleClickZoom
 * 복원까지 해야 해서 자체 `exitDrawing` 을 갖는다. 다중 점(`MultiPointDrawButton`)의
 * `exitDrawing` 은 이 헬퍼와 같은 3줄 + `isDrawing:false` 뿐이라 이 헬퍼로 대체 가능하다
 * (아직 이관하지 않았다).
 */
export function releaseDrawToolUi(
  map: OlMap,
  draw: Draw,
  selectButton: (id: string) => void
) {
  selectButton("");
  map.getViewport().style.cursor = DRAW_TOOL_EXIT_CURSOR;
  map.removeInteraction(draw);
}
